export const resCompiler = (data, output) => {
  return typeof data === "string"
    ? data?.toString()
    : output
    ? output.reduce((res, { name }) => {
        if (!name) return data.toString();
        return { ...res, [name]: data[name] ? data[name].toString() : data.toString() };
      }, {})
    : data.toString();
};
export const funtionNameCompiler = (str) => {
  const upstr = str.charAt(0).toUpperCase() + str.slice(1); // Capitalize the first letter

  return upstr.replace(/([0-9A-Z])/g, " $&");
};
